import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import { isObject } from 'util';
import { base64toUint8Array } from '../../utils/base64toUint8Array';
import { MobileAppHelperBaseService } from '../../fi-shared-services/mobile-app-helper-base.service';

let nextId = 0;

@Directive({
    selector: '[fiBtnMobileAppOpenCamera]',
    standalone: false,
})
export class FiBtnMobileAppOpenCameraDirective {
    @Output() fiBtnMobileAppOpenCamera = new EventEmitter();
    callbackName: string;

    constructor(private mobileAppHelper: MobileAppHelperBaseService) {
        this.callbackName = `FiBtnMobileAppOpenCameraFor:${++nextId}`;
    }

    @HostListener('click')
    onClick() {
        this.mobileAppHelper.takePicture(this.callbackName);
    }

    @HostListener('window:message', ['$event'])
    onMessage(e: MessageEvent) {
        // todo catch window:message in FiMobileAppHelperService
        if (isObject(e.data) && e.data.name == this.callbackName) {
            this.processCameraResponse(e);
        }
    }

    processCameraResponse(e: MessageEvent) {
        const file = new Blob([base64toUint8Array(e.data.fileData)], { type: 'image/jpeg' });
        (<any>file).name = 'picture.jpeg';
        this.fiBtnMobileAppOpenCamera.emit([file]);
    }
}
